<template>
  <div class="d-flex justify-center align-center splash">
    <v-card class="pa-6 login-card ma-6">
      <div class="text-center">
        <img src="/portal/ctp-logo.png" class="logo" />
        <h2 class="mt-2">Reset your password</h2>
        <p>We will send you an email to reset your password.</p>
      </div>
      <v-form
          ref="form"
          v-model="valid"
          lazy-validation
      >
        <v-text-field
            v-model="email"
            label="Email"
            name="email"
            required
            v-on:keyup.enter="requestResetPassword"
        ></v-text-field>


        <v-btn
            color="success"
            class="mb-4"
            @click="requestResetPassword"
        >
          Submit
        </v-btn>


      </v-form>
      <router-link :to="{ name: 'login'}">Return to login</router-link>
      <p class="mt-4 text-center">

        Having problems logging in? <br/>
        Click <a @click="openFreshdesk">here</a> to get help from support
      </p>
    </v-card>
  </div>
</template>

<script>
import {mapGetters, mapState} from "vuex";
export default {
  name: 'forgot_password',
  components: {
  },
  methods: {
    openFreshdesk: function(){
      FreshworksWidget('open', 'ticketForm');
    },
    requestResetPassword: function(){
      this.$store.dispatch("requestResetPassword", this.email)
    }
  },
  computed: {
    ...mapGetters({
    }),
    ...mapState({
    }),
  },
  data: function(){
    return {
      'email': ''
    }
  }
}
</script>